import {
    BlankQuestion,
    MultipleChoiceQuestion,
    QuizQuestionsItem
} from "../../../../../Client/Models";
import React from "react";
import {Box, Button, Center, Divider, IconButton, Stack} from "@chakra-ui/react";
import {BaseQuestionEditor} from "./BaseQuestionEditor";
import CustomList from "../../../../Utils/CustomList";
import {MdCheck} from "react-icons/md";

const MultipleChoiceQuestionEditor = (props: {
    question: MultipleChoiceQuestion,
    onSetQuestion: (question: QuizQuestionsItem) => void
    children?: React.ReactNode
}) => {
    return (
        <BaseQuestionEditor
            question={props.question as BlankQuestion}
            onSetQuestion={props.onSetQuestion}
            hasShowAnswer={true}>
            <Stack>
                <Center>
                    <Box w={'75%'}>
                        <CustomList
                            elements={props.question.options}
                            nameGetter={
                                (o: string) => o
                            }
                            onRename={
                                (o: string, name, index) => {
                                    const options = props.question.options;
                                    const optionName = options[index];
                                    const answer = props.question.answer;

                                    const correct = answer == optionName;

                                    options[index] = name;
                                    props.onSetQuestion({
                                        ...props.question,
                                        options: options
                                    })
                                    if (correct) {
                                        props.onSetQuestion({
                                            ...props.question,
                                            answer: name
                                        })
                                    }
                                }
                            }
                            onDelete={
                                (o: string, index) => {
                                    let options = props.question.options;
                                    options.splice(index, 1)
                                    props.onSetQuestion({
                                        ...props.question,
                                        options: options
                                    })
                                }
                            }
                            customElements={
                                (o: string, index) => {
                                    const options = props.question.options;
                                    const optionName = options[index];
                                    const answer = props.question.answer;

                                    const correct = answer == optionName;

                                    return (
                                        <IconButton
                                            variant={correct ? 'solid' : 'outline'}
                                            aria-label='Set Correct'
                                            fontSize='20px'
                                            icon={<MdCheck/>}
                                            onClick={() => {
                                                props.onSetQuestion({
                                                    ...props.question,
                                                    answer: optionName
                                                })
                                            }
                                            }
                                        />
                                    )
                                }
                            }
                        />
                    </Box>
                </Center>
                <Divider my={3}/>
                <Button
                    variant='outline'
                    onClick={() => {
                        let name = 'Optie ' + (props.question.options.length + 1)

                        if (props.question.options.length <= 0) {
                            props.onSetQuestion({
                                ...props.question,
                                answer: name
                            })
                        }

                        props.onSetQuestion({
                            ...props.question,
                            options: [...props.question.options, name]
                        })
                    }
                    }
                >
                    Optie toevoegen
                </Button>
            </Stack>

        </BaseQuestionEditor>
    )
}

export {
    MultipleChoiceQuestionEditor
}
